<template>
  <section class="intro">
    <div class="container">
      <div
        class="right aos-init aos-animate"
        data-aos="fade-left"
        data-aos-duration="2000"
      >
        <h2>Protection for the property owner and you as a tenant.</h2>
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon1.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>
              <td>
                <h3>Property Damage Liability</h3>
                <p>
                  Covers losses to property that doesn't belong to you. Like
                  your college dorm, landlord's apartment, or your neighbor's
                  property.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon2.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>
              <td>
                <h3>Personal Liability</h3>
                <p>
                  If a guest gets hurt, like from a dog bite, the insurer will
                  cover the necessary medical and legal expenses.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon3b.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>
              <td>
                <h3>Personal Property Coverage</h3>
                <p>Protect your stuff from fire, theft, vandalism and more.</p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
      <div style="clear: both"></div>
    </div>
  </section>
</template>
